import { Link } from "react-router-dom";
import styles from "../styles/pages.module.css";

export default function MudanzasSalamanca() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Mudanzas en Salamanca, Madrid</h1>
        <span className={styles.lastUpdated}>Mudanzas de lujo en el distrito más exclusivo de Madrid</span>

        <div style={{ textAlign: "center", margin: "1.5rem 0" }}>
          <img
            src="/assets/images/distrito-salamanca.webp"
            alt="Mudanzas en Salamanca"
            style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
          />
        </div>

        <p>
          El distrito de <strong>Salamanca</strong> es sinónimo de exclusividad, amplios pisos señoriales y familias que exigen un servicio de mudanza a la altura. En Britosa Mudanzas llevamos más de 25 años realizando traslados de alto standing en Madrid, y Salamanca es uno de los barrios donde más hemos trabajado.
        </p>

        <h2>Mudanzas premium en el barrio de Salamanca</h2>
        <p>
          Mudarse en Salamanca requiere un nivel de cuidado superior. Techos altos, suelos de madera noble, escaleras de mármol, ascensores antiguos con cabina reducida y mobiliario de diseño son la norma. Nuestro equipo está específicamente entrenado para este tipo de mudanzas.
        </p>
        <ul>
          <li><strong>Embalaje premium:</strong> Cartón doble, plástico de burbujas grueso, cantoneras y mantas acolchadas.</li>
          <li><strong>Protección de suelos y paredes:</strong> Evitamos cualquier roce o marca durante el traslado.</li>
          <li><strong>Técnicos especializados:</strong> Pianos, obras de arte, antigüedades y muebles de diseño.</li>
          <li><strong>Seguro ampliado:</strong> Cobertura total para bienes de alto valor.</li>
          <li><strong>Discreción absoluta:</strong> Uniforme corporativo, vehículos sin rotulación a petición.</li>
        </ul>

        <h2>Servicios que ofrecemos en Salamanca</h2>
        <ul>
          <li><strong>Mudanzas residenciales de lujo:</strong> Pisos señoriales, áticos dúplex y viviendas unifamiliares.</li>
          <li><strong>Mudanzas de oficinas:</strong> Traslados de bufetes de abogados, consultoras y despachos financieros.</li>
          <li><strong>Guardamuebles climatizado:</strong> Para obras de reforma o espera entre viviendas.</li>
          <li><strong>Montaje de mobiliario de diseño:</strong> Técnicos especializados en marcas premium.</li>
        </ul>

        <h2>Barrios de Salamanca que cubrimos</h2>
        <p>
          Recoletos, Goya, Parque de las Avenidas, Fuente del Berro, Guindalera, Lista, Castellana y todos los barrios del distrito de Salamanca.
        </p>

        <div style={{ background: "#f0f9ff", borderRadius: "8px", padding: "1.25rem", margin: "1.5rem 0", border: "1px solid #bae6fd" }}>
          <h3 style={{ marginTop: 0, color: "#0F4C75" }}>Mudanza premium en Salamanca</h3>
          <p style={{ marginBottom: "1rem" }}>
            Solicita tu presupuesto personalizado. Valoración in situ disponible.
          </p>
          <Link to="/presupuesto" style={{ display: "inline-block", padding: "0.6rem 1.4rem", background: "#F97316", color: "#fff", borderRadius: "6px", textDecoration: "none", fontWeight: 600 }}>
            Pedir presupuesto →
          </Link>
        </div>

        <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "2rem" }}>
          <a href="tel:+34691604880">691 60 48 80</a> · <a href="mailto:info@mudanzasbritosa.com">info@mudanzasbritosa.com</a>
        </p>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Britosa Mudanzas - Salamanca",
          "description": "Mudanzas de lujo en Salamanca, Madrid. Especialistas en traslados premium y embalaje de alta gama.",
          "url": "https://mudanzasbritosa.com/mudanzas-salamanca",
          "telephone": "+34691604880",
          "email": "info@mudanzasbritosa.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "C. Río Duero, 28934 Móstoles",
            "addressLocality": "Salamanca, Madrid",
            "addressRegion": "Madrid",
            "addressCountry": "ES"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.4272,
            "longitude": -3.6788
          },
          "areaServed": {
            "@type": "City",
            "name": "Salamanca"
          },
          "priceRange": "€€",
          "openingHours": "Mo-Su 08:00-22:00"
        })
      }} />
    </div>
  );
}
